import { css } from '@emotion/react'
import { Heading, HFlow, Icon, Theme, useTheme } from 'bold-ui'
import { ColorScale } from 'bold-ui/lib/styles/colors'
import { AccordionButton } from 'components/accordion/AccordionButton'
import { SideMenuList } from 'components/layout/SideMenu/SideMenuList'
import { ReactNode } from 'react'
import { AccordionItem, AccordionItemPanel } from 'react-accessible-accordion'

import { AcompanhamentoMenuTitle } from '../getAcompanhamentosSideMenuItems'

interface AcompanhamentoSideMenuItemProps {
  title: AcompanhamentoMenuTitle
  children: ReactNode
  isMenuActive: boolean
  icon: string
  alt?: string
  color: ColorScale
  onClickMenuItem: () => void
}
export function AcompanhamentosSideMenuItem(props: AcompanhamentoSideMenuItemProps) {
  const { title, children, isMenuActive, icon, alt, color, onClickMenuItem } = props

  const theme = useTheme()

  const styles = createStyles(theme, isMenuActive, color)

  return (
    <AccordionItem uuid={title}>
      <AccordionButton
        style={styles.accordionButton}
        wrapperStyle={styles.accordionButtonWrapper}
        onClick={onClickMenuItem}
      >
        <HFlow alignItems='center' justifyContent='space-between' style={styles.header}>
          <HFlow hSpacing={0.5} alignItems='center'>
            <img src={icon} alt={alt} />
            <Heading level={4} color='inherit'>
              {title}
            </Heading>
          </HFlow>
          <Icon icon='angleRight' style={styles.angleRight} />
        </HFlow>
      </AccordionButton>
      <AccordionItemPanel>
        <SideMenuList>{children}</SideMenuList>
      </AccordionItemPanel>
    </AccordionItem>
  )
}

const createStyles = (theme: Theme, isMenuActive: boolean, color: ColorScale) => ({
  accordionButtonWrapper: css`
    padding-bottom: 0;
  `,
  accordionButton: css`
    padding: 1rem;
    background-color: ${theme.pallete.gray.c100};
    overflow: visible;
    margin: 0;

    &[aria-expanded='true'] div:first-child > svg {
      transform: rotate(-90deg);
    }

    &:hover {
      border-color: ${color.c40};
      background-color: ${color.c90};
    }

    &:focus {
      border-radius: 2px;
      position: relative;
      z-index: 4;
    }

    border-right: ${isMenuActive ? `4px solid ${color.c40}` : 0};
    border-radius: 0;
  `,
  header: css`
    color: ${color.c40};
  `,
  angleRight: css`
    color: ${theme.pallete.gray.c10};
  `,
})
